module.exports = __webpack_public_path__ + "img/background2.6876e44c.jpeg";